<div class="overflow-hidden">
  <!-- Carousel Container -->
  <div class="carousel-container position-relative mb-4">
    <!-- Slides -->
    <div class="position-relative w-100 h-100 d-flex align-items-center justify-content-center">
      @for (answer of answers; track answer.Id; let i = $index) {
        <div class="carousel-slide position-absolute" [ngClass]="'slide-' + getSlidePosition(i)">
          <div class="video-answer w-100 overflow-hidden">
            <!-- Video Player -->
            @if (answer.VideoId) {
              <fgbcl-video-player [videoId]="answer.VideoId" [allowPlayback]="isCenterSlide(i)"></fgbcl-video-player>
            } @else {
              <img class="answer-image" [src]="answer.ImageUrl | contentImage: '7'" />
            }
            <!-- Answer Content -->
            <div class="answer-content bg-primary text-white text-center">
              <div class="answer-body" [@slideContent]="isCenterSlide(i) ? 'visible' : 'hidden'">
                <p class="mb-0 fw-bold">{{ answer.Title }}</p>
                <button
                  class="btn answer-button fw-bold"
                  (click)="onAnswerSelected(answer)"
                  [ngClass]="answer.Id === selectedAnswerId() ? 'btn-success' : 'btn-secondary'"
                  [disabled]="loading || !isCenterSlide(i)"
                >
                  {{ answer.Id === selectedAnswerId() ? 'Selected' : 'Select' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Navigation Arrows -->
    @if (!isFirstSlide()) {
      <button
        (click)="goToPrev()"
        class="nav-btn previous-slide-btn btn bg-disabled position-absolute top-50 start-0 translate-middle-y rounded-circle p-0"
        [disabled]="loading"
      >
        <span class="material-symbols-outlined text-black play-button-icon"> chevron_left</span>
      </button>
    }

    @if (!isLastSlide()) {
      <button
        (click)="goToNext()"
        class="nav-btn next-slide-btn btn bg-disabled position-absolute top-50 end-0 translate-middle-y rounded-circle p-0"
        [disabled]="loading"
      >
        <span class="material-symbols-outlined text-black play-button-icon"> chevron_right</span>
      </button>
    }
  </div>

  <!-- Dots Navigation -->
  @if (answers && answers.length > 1) {
    <div class="d-flex justify-content-center align-items-center gap-2">
      @for (answer of answers; track answer.Id; let i = $index) {
        <button
          (click)="goToSlide(i)"
          class="btn p-0 border-0 rounded-pill transition-all"
          [ngClass]="i === currentIndex ? 'active-dot' : 'inactive-dot'"
          [attr.aria-label]="'Go to answer ' + (i + 1)"
          [disabled]="loading"
        ></button>
      }
    </div>
  }
</div>
